module.exports = __webpack_public_path__ + "static/media/ThumbnailStill12.3f84d643.png";